import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const TopFilterContainer = styled.div`
  display: flex;
  width: 1060px;
  align-items: center;
  gap: 40px;
`;

export const TopFilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`;

export const PeriodChipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MeetingRoomLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
